import httpClient from '@/http-client'

export const dailySaleItem = data => {
  return httpClient
    .get('/api/v1/reports/daily-sale-items', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const dailySaleItemExcel = attributes => {
  return httpClient
    .post('/api/v1/reports/daily-sale-item-excel-exports', attributes, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const saleItemDetail = data => {
  return httpClient
    .get('/api/v1/reports/sale-item-details', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const stockInDetail = data => {
  return httpClient
    .post('/api/v1/reports/stock-in-details', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const stockInDetailExcel = attributes => {
  return httpClient
    .post('/api/v1/reports/stock-in-detail-excel-exports', attributes, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const stockInSummary = data => {
  return httpClient
    .post('/api/v1/reports/stock-in-summaries', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const stockInSummaryExcel = data => {
  return httpClient
    .post('/api/v1/reports/stock-in-summary-excel-exports', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const detailInventoryList = data => {
  return httpClient
    .get('/api/v1/reports/detail-inventory-lists', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const detailInventoryListToExcel = data => {
  return httpClient
    .post('/api/v1/reports/detail-inventory-lists-to-excel', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const summaryInventoryList = data => {
  return httpClient
    .get('/api/v1/reports/summary-inventory-lists', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const summaryInventoryListExcel = attributes => {
  return httpClient
    .post('/api/v1/reports/summary-inventory-list-excel-exports', attributes, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const productItemList = (Options = {}) => {
  return httpClient
    .get('/api/v1/reports/product-item-lists', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const productItemListExcel = data => {
  return httpClient
    .post('/api/v1/reports/product-item-lists/excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const purchaseOrderList = data => {
  return httpClient
    .get('/api/v1/reports/purchase-order-details', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const purchaseOrderSummary = data => {
  return httpClient
    .post('/api/v1/reports/purchase-order-summaries', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const purchaseOrderSummaryExcel = data => {
  return httpClient
    .post('/api/v1/reports/purchase-order-summaries/excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const monthlySaleItem = data => {
  return httpClient
    .post('/api/v1/reports/monthly-sale-items', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const monthlySaleItemExcel = attributes => {
  return httpClient
    .post('/api/v1/reports/monthly-sale-item-excel-exports', attributes, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const stockTransfer = data => {
  return httpClient
    .get('/api/v1/reports/stock-transfers', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const stockTransferExcel = attributes => {
  return httpClient
    .post('/api/v1/reports/stock-transfers-excel-exports', attributes, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const yearlySaleItem = data => {
  return httpClient
    .get('/api/v1/reports/yearly-sale-items', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const yearlySaleItemExcel = data => {
  return httpClient
    .post('/api/v1/reports/yearly-sale-items/excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const productList = attributes => {
  return httpClient
    .get('/api/v1/reports/inventory/product-lists', attributes)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const getLocation = branch_id => {
  return httpClient
    .post('/api/v1/reports/inventory/locations', branch_id)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const productListExcel = attributes => {
  return httpClient
    .post('/api/v1/reports/inventory/product-lists/excels', attributes, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const productSerial = data => {
  return httpClient
    .post('/api/v1/reports/inventory/product-serials', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const productSerialExcel = data => {
  return httpClient
    .post('/api/v1/reports/inventory/product-serials/excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const inventoryMinMax = (Options = {}) => {
  return httpClient
    .get('/api/v1/reports/inventory-min-max', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const inventoryMinMaxExcel = data => {
  return httpClient
    .post('/api/v1/reports/inventory-min-max', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const productWarrantyExpired = (Options = {}) => {
  return httpClient
    .get('/api/v1/reports/product-warranty-expireds', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.resolve(error.response.data))
}
export const productWarrantyExpiredExcel = data => {
  return httpClient
    .post('/api/v1/reports/product-warranty-expireds/excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.resolve(error.response.data))
}
export const stockAdjustment = (Options = {}) => {
  return httpClient
    .post('/api/v1/reports/stock-adjustments', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.resolve(error.response.data))
}
export const stockAdjustmentExcel = data => {
  return httpClient
    .post('/api/v1/reports/stock-adjustments/excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.resolve(error.response.data))
}
export const stockReturn = (Options = {}) => {
  return httpClient
    .post('/api/v1/reports/stock-returns', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.resolve(error.response.data))
}
export const stockReturnExcel = data => {
  return httpClient
    .post('/api/v1/reports/stock-returns/excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.resolve(error.response.data))
}
export const detailTransfer = (Options = {}) => {
  return httpClient
    .post('/api/v1/reports/detail-transfers', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.resolve(error.response.data))
}
export const detailTransferExcel = data => {
  return httpClient
    .post('/api/v1/reports/detail-transfers/excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.resolve(error.response.data))
}
export const transferPendingStatus = (Options = {}) => {
  return httpClient
    .post('/api/v1/reports/transfer-pending-status', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.resolve(error.response.data))
}
export const transferPendingStatusExcel = data => {
  return httpClient
    .post('/api/v1/reports/transfer-pending-status/excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.resolve(error.response.data))
}
export const inventoryMinMax2 = (Options = {}) => {
  return httpClient
    .get('/api/v1/reports/inventory-min-max-2', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const inventoryMinMax2Excel = data => {
  return httpClient
    .post('/api/v1/reports/inventory-min-max-2', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const insertCalculateMaxMin = data => {
  return httpClient
    .post('/api/v1/reports/insert-calculate-max-mins', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export default {
  dailySaleItem,
  dailySaleItemExcel,
  saleItemDetail,
  stockInDetail,
  stockInDetailExcel,
  stockInSummary,
  stockInSummaryExcel,
  detailInventoryList,
  summaryInventoryList,
  productItemList,
  purchaseOrderList,
  purchaseOrderSummary,
  monthlySaleItem,
  stockTransfer,
  yearlySaleItem,
  monthlySaleItemExcel,
  stockTransferExcel,
  productList,
  productSerial,
  summaryInventoryListExcel,
  detailInventoryListToExcel,
  productItemListExcel,
  purchaseOrderSummaryExcel,
  yearlySaleItemExcel,
  productListExcel,
  productSerialExcel,
  getLocation,
  inventoryMinMax,
  inventoryMinMaxExcel,
  productWarrantyExpired,
  productWarrantyExpiredExcel,
  stockAdjustment,
  stockAdjustmentExcel,
  stockReturn,
  stockReturnExcel,
  detailTransfer,
  detailTransferExcel,
  transferPendingStatus,
  transferPendingStatusExcel,
  inventoryMinMax2,
  inventoryMinMax2Excel,
  insertCalculateMaxMin
}
